import { BaseEntity } from './base-entity';

export class ActionView{
    ID: number = 0;
    Model: string = null;
    Naziv: string = null;
    VrednostRola: boolean = null;
    VrednostKorisnik: boolean = null;
    DefaultValue: boolean = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Model = input.Model;
        this.Naziv = input.Naziv;
        this.VrednostRola = input.VrednostRola;
        this.VrednostKorisnik = input.VrednostKorisnik;
        this.DefaultValue = input.DefaultValue;
        
        return this;
    }
}